import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-map',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M22 10v-.78251c0-1.93962 0-2.90942-.5858-3.51199-.5858-.60256-1.5286-.60256-3.4142-.60256h-2.0786c-.9174
            0-.925-.00178-1.7499-.4146l-3.3316-1.6672c-1.39106-.6961-2.08658-1.04415-2.82752-1.01996-.74095.02419-1.41361.4169-2.75893
            1.20233l-1.22787.71686c-.98819.57692-1.48229.86539-1.75394 1.34527C2 5.74553 2 6.32993 2 7.49873v8.21697c0
            1.5357 0 2.3036.34226 2.731.22775.2843.5469.4755.89974.5389.53026.0952 1.17948-.2838 2.47787-1.0419.88169-.5147
            1.73024-1.0493 2.785-.9043.88382.1214 1.70513.6791 2.49513 1.0744" />
      <path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 2v15" />
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v4.5" />
      <path stroke="currentColor" stroke-width="1.5"
            d="M18.3083 21.6835c-.2168.203-.5066.3165-.8082.3165s-.5914-.1135-.8082-.3165c-1.9856-1.8705-4.6464-3.96-3.3488-6.9937C14.0447
            13.0496 15.7289 12 17.5001 12c1.7712 0 3.4554 1.0496 4.157 2.6898 1.296 3.0298-1.3583 5.1296-3.3488 6.9937Z" />
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
            d="M17.5 16.5h.009" />
    </svg>
  `
})
export class IconMapComponent {
  size: InputSignal<number> = input<number>(24);
}
